module.exports = __webpack_public_path__ + "static/media/YuhanWang_Resume.f0327ccb.pdf";